import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./HomeSiteAddressList.module.css";
import RadioButton from "../RadioButton";
import { AddressInfoItem } from "../AddressInfoItem/AddressInfoItem";
import { useTranslation } from "react-i18next";

export function HomeSiteAddressList({
  onClick,
  onCancel,
  addresses,
  header,
  userHomesiteAddress,
  addresslabel
}) {
  const { t } = useTranslation();
  const [selectedAddress, setSelectedAddress] = useState(
    addresses.find(
      (address) => address?.groupId == userHomesiteAddress?.groupId
    ) || null
  );

  useEffect(() => {
    if (userHomesiteAddress && addresses) {
      setSelectedAddress(
        addresses.find(
          (address) => address?.groupId == userHomesiteAddress?.groupId
        ) || null
      );
    }
  }, [userHomesiteAddress, addresses]);
  const [lastSelectedAddress, setLastSelectedAddress] = useState(null);
  const [showAddresses, setShowAddresses] = useState(false);

  const handleSelect = (address) => {
    setSelectedAddress(address);
  };

  const handleCancel = () => {
    if (lastSelectedAddress !== null) {
      setSelectedAddress(lastSelectedAddress);
    }
    onCancel();
  };

  const handleConfirm = () => {
    setLastSelectedAddress(selectedAddress);
    onClick(selectedAddress);
  };

  const displayedAddresses = showAddresses ? addresses : addresses.slice(0, 3);

  // console.log("here", userHomesiteAddress);

  return (
    <div className={styles.container}>
      <div className={styles.header}>{header}</div>
      <div className={styles.content}>
        {displayedAddresses.map((address, index) => (
          <div className={styles.selectContainer} key={index}>
            <div className={styles.radioButton}>
              <RadioButton
                value={address.key}
                isSelected={selectedAddress === address}
                onChange={() => handleSelect(address)}
              />
            </div>
            <div className={styles.addressDetails}>
              {addresslabel && (
                <div className={styles.addresslabel}>
                  <strong>{addresslabel(address)}</strong> 
                </div>
              )}
              <AddressInfoItem address={address} />
            </div>
          </div>
        ))}
      </div>

      <div className={styles.buttons}>
        {addresses.length > 3 && (
          <button
            className={styles.moreButton}
            onClick={() => setShowAddresses(!showAddresses)}
          >
            {showAddresses ? t("Less") : t("More")}
          </button>
        )}
      </div>

      <div className={styles.buttons}>
        {header === "Your Address" ? (
          <div className={styles.buttonsContainer}>
            <button
              className={styles.confirmButton}
              onClick={handleConfirm}
              disabled={!selectedAddress}
            >
              {t("Confirm")}
            </button>
          </div>
        ) : (
          <div className={styles.buttonsContainer}>
            <button className={styles.cancelButton} onClick={handleCancel}>
              {t("Cancel")}
            </button>
            <button
              className={styles.confirmButton}
              onClick={handleConfirm}
              disabled={!selectedAddress}
            >
              {t("Confirm")}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

HomeSiteAddressList.propTypes = {
  onClick: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  addresses: PropTypes.arrayOf(
    PropTypes.shape({
      addressLabel: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      country: PropTypes.string.isRequired,
      address1: PropTypes.string.isRequired,
      address2: PropTypes.string,
      city: PropTypes.string.isRequired,
      state: PropTypes.string.isRequired,
      zipCode: PropTypes.string.isRequired,
    })
  ).isRequired,
  header: PropTypes.string.isRequired,
};
